import styles from "../css/SentenceGenerateButton.module.css";
import { SentenceGenerateButtonStatus } from "../model/SentenceGenerateButtonStatus";
import { ReactComponent as AIGenerateIcon } from "../../../img/iconImgAllAiGenerate.svg";
import { ReactComponent as AIGenerateAbledIcon } from "../../../img/iconImgAllAiGenerateAbled.svg";
import { ClipLoader } from "react-spinners";

interface SentenceGenerateButtonProps {
  status: SentenceGenerateButtonStatus;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function SentenceGenerateButton(
  props: SentenceGenerateButtonProps
) {
  function handleOnClickButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    props.onClick(e);
  }

  return (
    <>
      <div className={styles.button} onClick={handleOnClickButton}>
        {props.status === SentenceGenerateButtonStatus.active && (
          <AIGenerateAbledIcon
            className={styles.icon}
            style={{
              color: "var(--icon-active-color)",
            }}
          />
        )}
        {props.status === SentenceGenerateButtonStatus.inactive && (
          <AIGenerateIcon
            className={styles.icon}
            style={{
              color: "var(--icon-secondary-color)",
            }}
          />
        )}
        {props.status === SentenceGenerateButtonStatus.onLoading && (
          <ClipLoader
            loading={true}
            size={12}
            color="var(--icon-disabled-color)"
          />
        )}
      </div>
    </>
  );
}
